import { Badge as AntdBadge, type BadgeProps as AntdBadgeProps } from "antd";

import type { AvE2EProps } from "../types";

type BadgeProps = AntdBadgeProps & AvE2EProps;

function Badge({ testIdPrefix, ...restProps }: BadgeProps) {
  return <AntdBadge data-testid={`${testIdPrefix}-badge`} {...restProps} />;
}

export { Badge };
export type { BadgeProps };
